import React, { useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "./BarChart.css";
const BarChart = ({ fleetApiCount })  => {
// const BarChart =  ({ categories = [], series = [] }) => {
  const categories = []
  const series = []
  fleetApiCount.map((val) => {
    categories.push(val['label'])
    series.push(val['value'])
  })
  // "categories",categories)
  // "series",series)
  // const categories = Object.keys(fleetCount);
  // const series = Object.values(fleetCount);
  const options = {
    chart: {
      type: "column",
      // type: "columnrange",
    },
    rangeSelector: {
      selected: 2,
    },
    title: {
      text: "Stellantis Fleet Info",
      align: "left",
    },
    xAxis: {
      categories: categories,
      crosshair: true,
      accessibility: {
        description: "Category",
      },
    },
    yAxis: {
      //   type: "logarithmic",
      min: 1,
      title: {
        text: "Count",
      },
    },
    // tooltip: {
    //   valueSuffix: " (1000 MT)",
    // },
    tooltip: {
      pointFormat:
        "Category: <b>{point.category}</b><br>" +
        "Count: <b> {point.y}</b><br>",
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        minPointLength: 3,
      },
    },
    series: [
      {
        name: "Category",
        data: series,
      },
    ],
  };
  return <HighchartsReact highcharts={Highcharts} options={options} />;
};
export default BarChart;